/**
 * Classic P: crucibles (docs/spec/03 §2). Four small boxes with magic-wall floors, each under a
 * chute of boulders held by one cell of dirt. The walls share one timer, started by the first
 * boulder in: feed the rest before it runs out, and collect the diamonds in the basin below.
 */

import type { CaveDef } from '../types';

export const caveP: CaveDef = {
  id: 'P',
  name: 'CRUCIBLES',
  hint: 'Light one crucible and the clock starts for all four.',
  intermission: false,
  colors: [8, 3, 1],
  diamondValue: 25,
  extraValue: 50,
  magicWallTime: 12,
  fill: { base: '.', items: [['r', 12], ['d', 8]] },
  levels: [
    { seed: 2901, diamonds: 20, time: 120 },
    { seed: 2902, diamonds: 23, time: 110 },
    { seed: 2903, diamonds: 26, time: 100 },
    { seed: 2904, diamonds: 29, time: 95 },
    { seed: 2905, diamonds: 32, time: 90 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'W.....wrw..???????????..wrw..??????????W',
    'W.P...wrw..???????????..wrw..??????????W',
    'W.....wrw..???????????..wrw..??????????W',
    'W???..wrw..??.......??..wrw..?.......??W',
    'W???..wrw..??..wrw..??..wrw..?..wrw..??W',
    'W???.......??..wrw..??.......?..wrw..??W',
    'W???.w   w.??..wrw..??.w   w.?..wrw..??W',
    'W???.w   w.??..wrw..??.w   w.?..wrw..??W',
    'W???.wmmmw.??..wrw..??.wmmmw.?..wrw..??W',
    'W???.ww ww.??.......??.ww ww.?.......??W',
    'W???... ...??.w   w.??... ...?.w   w.??W',
    'W???... ...??.w   w.??... ...?.w   w.??W',
    'W???... ...??.wmmmw.??... ...?.wmmmw.??W',
    'W???... ...??.ww ww.??... ...?.ww ww.??W',
    'W???... ...??... ...??... ...?... ...??W',
    'W.wwwww wwwwwwww wwwwwwww wwwwwww wwww.W',
    'W                                      W',
    'W                                      W',
    'W                                      W',
    'W....................................X.W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
